<template>
	<div class="date-range-picker-container">
		<!-- 开始日期选择器 -->
		<el-date-picker v-model="startDate" type="date" placeholder="选择开始日期" :disabled="disabled"
			:picker-options="startPickerOptions" value-format="yyyy-MM-dd" @change="handleDateChange"></el-date-picker>

		<!-- 分隔符 -->
		<span class="date-separator">至</span>

		<!-- 结束日期选择器 -->
		<el-date-picker v-model="endDate" type="date" placeholder="选择结束日期" :disabled="disabled || !startDate"
			:picker-options="endPickerOptions" value-format="yyyy-MM-dd" @change="handleDateChange"></el-date-picker>
	</div>
</template>

<script>
	export default {
		name: "DateRangePicker",
		props: {
			// 初始开始日期（可选，格式：yyyy-MM-dd）
			initStartDate: {
				type: String,
				default: "",
			},
			// 初始结束日期（可选，格式：yyyy-MM-dd）
			initEndDate: {
				type: String,
				default: "",
			},
			// 是否禁用选择器
			disabled: {
				type: Boolean,
				default: false,
			},
			// 默认日期范围类型（可选：today-今日，empty-空）
			defaultRange: {
				type: String,
				default: "empty",
				validator: (val) => ["today", "empty"].includes(val),
			},
		},
		data() {
			return {
				startDate: "", // 绑定开始日期
				endDate: "", // 绑定结束日期
			};
		},
		computed: {
			// 开始日期选择器配置：无任何禁用（支持任意日期）
			startPickerOptions() {
				return {
					disabledDate: () => false, // 所有日期都可选（关键修改）
				};
			},
			// 结束日期选择器配置：仅禁止选择「早于开始日期」的日期
			endPickerOptions() {
				const _this = this;
				return {
					disabledDate: (time) => {
						// 若已选开始日期，禁止结束日期 < 开始日期（核心限制）
						if (_this.startDate) {
							const startTimestamp = new Date(_this.startDate).getTime();
							// 关键逻辑：time（当前鼠标悬浮的日期）的时间戳 < 开始日期的时间戳 → 禁用
							return time.getTime() < startTimestamp;
						}
						return false; // 未选开始日期时，先不限制（但已通过disabled禁用结束日期选择器）
					},
				};
			},
		},
		watch: {
			// 监听父组件传递的初始值，动态同步
			initStartDate(newVal) {
				this.startDate = newVal;
			},
			initEndDate(newVal) {
				this.endDate = newVal;
			},
		},
		created() {
			// 初始化默认日期范围
			this.initDefaultRange();
		},
		methods: {
			// 初始化默认日期范围
			initDefaultRange() {
				const today = this.formatDate(new Date().toDateString()); // 今天（yyyy-MM-dd）

				switch (this.defaultRange) {
					case "today":
						// 默认：今天-今天（允许结束日期=开始日期，若需禁止可调整）
						this.startDate = today;
						this.endDate = today;
						break;
					case "empty":
						// 默认：空，优先使用父组件传递的初始值
						this.startDate = this.initStartDate;
						this.endDate = this.initEndDate;
						break;
				}

				// 初始化后触发回调，让父组件获取默认值
				this.handleDateChange();
			},

			// 格式化日期：将 "Wed Aug 24 2025" 转为 "2025-08-24"
			formatDate(dateStr) {
				const date = new Date(dateStr);
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份0-11，补0为两位数
				const day = String(date.getDate()).padStart(2, "0"); // 日期补0为两位数
				return `${year}-${month}-${day}`;
			},

			// 日期变化时，向父组件传递选择结果
			handleDateChange() {
				this.$emit("dateChange", {
					startDate: this.startDate, // 开始日期（yyyy-MM-dd）
					endDate: this.endDate, // 结束日期（yyyy-MM-dd）
					isComplete: !!this.startDate && !!this.endDate, // 是否完整选择
					isValid: this.startDate && this.endDate ?
						new Date(this.endDate) > new Date(this.startDate) : false, // 是否符合「结束>开始」规则
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	.date-range-picker-container {
		display: flex;
		align-items: center;
		gap: 12px;

	}

	.date-separator {
		color: #666;
		font-size: 14px;
	}


	::v-deep .el-date-editor {
		width: 180px !important;
	}
</style>